import $ from 'jquery';

import Navigation from '../components/Navigation';
import LiveSearch from '../components/LiveSearch';
import CartMini from '../components/CartMini';

export default class StaticHeader {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.data = section.data;
    this.toggleStickyDesktopNav = this.toggleStickyDesktopNav.bind(this);
    this.toggleStickyMobileNav = this.toggleStickyMobileNav.bind(this);

    // Header
    this.headerSettings = window.headerJSON;
    this.window = $(window);
    this.body = $('body');
    this.mainHeader = $('.main-header');
    this.minimalHeader = $('.header-minimal', this.el);
    this.mainHeaderWrap = $('.main-header-wrap', this.el);
    this.fullNav = $('nav.full', this.$el);
    this.compactNav = $('nav.compact', this.$el);
    this.slideshow = $('.slideshow', this.$el);
    this.actionLinks = $('.main-header .action-links', this.el);
    this.tools = $('.tools', this.el);
    this.toolsGroup = $('.main-header--tools-group', this.el);
    this.branding = $('.store-title, .logo', this.el);
    this.bodyContent = $('.page-body-content');
    this.dropdowns = this.el.querySelectorAll('.dropdown-wrap');

    this.checkDropdown();

    if (!this.body.hasClass('template-password') && this.data.currency_switcher_enabled) {
      this._initializeCurrency();
      $(document).on('initialize-currency.header', this._initializeCurrency.bind(this));
    }

    if (!this.body.hasClass('template-index' && this.slideshow.length && (this.slideshow.attr('data-full-width') === 'true'))) {
      if (this.compactNav.length) { this.compactNav.addClass('bordered'); } else { this.compactNav.removeClass('bordered'); }
      if (this.fullNav.length) { this.fullNav.addClass('bordered'); } else { this.fullNav.removeClass('bordered'); }
    }

    if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
      this.tools = $('.main-header--tools-left', this.el);
    }

    this.positionBodyOffset();

    if (!($(window).width() < 720)) {
      this.toggleStickyDesktopNav();
    } else {
      this.toggleStickyMobileNav();
    }

    this.navigation = new Navigation({ el: 'nav.full' });
    this.liveSearch = new LiveSearch(
      this.el.querySelector('[data-live-search]'),
      {
        enabled: this.data.live_search_enabled,
        display: this.data.live_search_display,
      },
    );

    $('.mini-cart-wrap', this.el).on('click.header', this.toggleMiniCart.bind(this));
    $('.mini-cart.active', this.el).on('click.header', event => event.stopPropagation());
    $('[name=currencies]', this.el).on('change.header', this.switchCurrency.bind(this));
    $(document).on('switch-currency.header', this.switchCurrency.bind(this));
    $(document).on('position-body-offset.header', this.switchCurrency.bind(this));
    $(document).on('navigation-resize.header', () => this.positionBodyOffset());

    this.window.on('resize.header', () => this.checkDropdown());
    this.window.on('scroll.header', this.toggleStickyMobileNav);
    this.window.on('scroll.header', this.toggleStickyDesktopNav);

    if (
      this.mainHeaderWrap.attr('data-header-layout') === 'minimal'
      || this.mainHeaderWrap.attr('data-header-layout') === 'minimal-sticky'
    ) {
      document.documentElement.classList.add('header-layout-minimal');
    } else {
      document.documentElement.classList.remove('header-layout-minimal');
    }

    this.window.on('resize.header', () => {
      if (this.mainHeaderWrap.attr('data-header-layout') === 'minimal') {
        this.positionBodyOffset();
        this.toggleStickyMobileNav();
        this.toggleStickyDesktopNav();
      }
    });

    this.cartMini = new CartMini();
  }

  _initializeCurrency() {
    Currency.format = Theme.currencySwitcherFormat;
    Currency.money_with_currency_format = {};
    Currency.money_with_currency_format[Theme.currency] = Theme.moneyFormatCurrency;
    Currency.money_format = {};
    Currency.money_format[Theme.currency] = Theme.moneyFormat;

    const newCurrency = Currency.cookie.read();

    if (newCurrency && $(`[name=currencies] option[value=${newCurrency}]`)) {
      Currency.currentCurrency = newCurrency;
    } else if (Theme.defaultCurrency) {
      Currency.currentCurrency = Theme.defaultCurrency;
      Currency.cookie.write(Theme.defaultCurrency);
    } else {
      Currency.currentCurrency = Theme.currency;
      Currency.cookie.write(Theme.currency);
    }

    $('[name=currencies]', this.el).val(Currency.currentCurrency);

    // fix customer account pages
    const $doubleMoneyElements = $('span.money span.money');
    for (let i = 0; i < $doubleMoneyElements.length; i++) {
      const $moneyElement = $($doubleMoneyElements[i]);
      $moneyElement.parents('span.money').removeClass('money');
    }

    Currency.convertAll(Theme.currency, Theme.currency);

    // save the current price
    const $moneyElements = $('span.money');
    for (let i = 0; i < $moneyElements.length; i++) {
      const $moneyElement = $($moneyElements[i]);
      $moneyElement.attr(`data-currency-${Theme.currency}`, $moneyElement.html());
    }

    if (Theme.currencySwitcher) {
      this.switchCurrency();
    }
  }

  positionBodyOffset() {
    if (this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) {
      if (this.window.width() < 720) { return; }
      this.bodyContent
        .css({ marginTop: this.mainHeader.outerHeight() });
    } else {
      this.bodyContent.css({ marginTop: '' });
    }
  }

  toggleStickyDesktopNav() {
    if ($('.pxs-announcement-bar').length !== 0) {
      if (!($(window).width() > 720)) { return; }
      if (!this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) { return; }

      if (!$('.pxs-announcement-bar').length || ($('.pxs-announcement-bar').length && $(window).scrollTop() > $('.pxs-announcement-bar').outerHeight())) {
        this.mainHeaderWrap
          .css({
            position: 'fixed',
            top: 0,
          });

          this.bodyContent.css({ marginTop: this.mainHeaderWrap.outerHeight() });
      } else {
        this.mainHeaderWrap
          .css({
            position: 'absolute',
            top: $('.pxs-announcement-bar').outerHeight(),
          });

        this.bodyContent.css({ marginTop: this.mainHeaderWrap.outerHeight() });
      }
    }
  }

  toggleStickyMobileNav() {
    if (!($(window).width() < 720)) { return; }
    if (!this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) { return; }

    if (!$('.pxs-announcement-bar').length || ($('.pxs-announcement-bar').length && $(window).scrollTop() > $('.pxs-announcement-bar').outerHeight())) {
      this.mainHeaderWrap.addClass('header-mobile-stick')
        .css({
          position: '',
          top: 0,
        });

      this.bodyContent
        .css({ marginTop: this.mainHeaderWrap.outerHeight() });
    } else {
      this.mainHeaderWrap.removeClass('header-mobile-stick')
        .css({
          position: 'absolute',
          top: $('.pxs-announcement-bar').outerHeight(),
        });

      this.bodyContent
        .css({ marginTop: this.mainHeaderWrap.outerHeight() });
    }
  }

  toggleMiniCart(e) {
    e.preventDefault();
    e.stopPropagation();

    this.cartMini.open();
  }

  switchCurrency(e) {
    let $switcher = $('[name=currencies]', this.el);
    let newCurrency = $switcher.val();

    if (e !== undefined) {
      $switcher = $(e.currentTarget);

      if (($switcher !== undefined) && (($switcher != null ? $switcher.attr('name') : undefined) === 'currencies')) {
        // If one switcher is switched, all switchers must switch
        $('[name=currencies]', this.el).val($switcher.val());
        newCurrency = $switcher.val();
      }
    }

    if ((newCurrency === null) || (newCurrency === '')) {
      newCurrency = Theme.currency;
    }

    const $moneyElements = $('span.money');

    for (let i = 0; i < $moneyElements.length; i++) {
      const $moneyElement = $($moneyElements[i]);

      if ($moneyElement.text() === '') {
        $moneyElement.attr('data-orig-price', 'none');
      }
      $moneyElement.toggleClass('no-price', $moneyElement.text() === '');
      $moneyElement.html($moneyElement.attr(`data-currency-${Theme.currency}`));
      $moneyElement.attr('data-currency', Theme.currency);
    }

    Currency.convertAll(Theme.currency, newCurrency);
    Currency.currentCurrency = newCurrency;
    Currency.cookie.write(newCurrency);
    $('.selected-currency', this.el).text(Currency.currentCurrency);
  }

  checkDropdown() {
    for (let i = 0; i < this.dropdowns.length; i++) {
      this.dropdowns[i].classList.remove('dropdown-right');
    }

    for (let i = 0; i < this.dropdowns.length; i++) {
      if(this.dropdowns[i].getBoundingClientRect().right + this.dropdowns[i].offsetWidth > window.innerWidth) {
        this.dropdowns[i].classList.add('dropdown-right');
      } else {
        this.dropdowns[i].classList.remove('dropdown-right');
      }
    }
  }

  onSectionUnload() {
    this.navigation.unload();
    this.liveSearch.unload();
    $('[data-cart-mini-toggle]', this.el).off('click.header');
    $('[name=currencies]', this.el).off('change.header');
    $(document).off('initialize-currency.header');
    $(document).off('switch-currency.header');
    $(document).off('position-body-offset.header');
    $(document).off('navigation-resize.header');
    $('body').off('click.header');
    this.window.off('scroll.header');
    this.window.off('scroll.header');
    this.window.off('resize.header');
    this.window.off('load.header');
    document.documentElement.classList.remove('header-layout-minimal');
  }
}
